<template>
  <div class="qr-code-component">

  </div>
</template>

<script>
import QRCode from 'qrcode'

export default {
  data() {
    return {
      qrObj: ''
    }
  },
  methods: {
    // 创建二维码的方法，返回被创建的实例  
    creat(text = '', options, callback) {
      const defaultOptions = {
        width: 256,
        height: 256,
        margin: 0
      }
      if (Object.prototype.toString.call(options) === '[object Object]') {
        Object.assign(defaultOptions, options)
      }
      this.$nextTick(() => {
        this.clear()
        QRCode.toCanvas(text, defaultOptions, (err, canvas) => {
          if (err) throw err
          this.$el.appendChild(canvas)
          if (typeof options === 'function' && !callback) {
            options()
            return
          }
          if (typeof callback === 'function') {
            callback()
          }
        })
      })
    },
    clear() {
      this.$el.innerHTML = ''
    }
  }
}
</script>
